import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as authentication } from './authentication';
import { reducer as modal } from './modal';
import { reducer as alert } from './alert';
import { History } from 'history';

const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    authentication,
    modal,
    alert,
  });

export default createRootReducer;
